/**
 * 合法环境变量列表
 */
const envList = ['SERVER_GROWP', 'SERVER_GROWP_V2'] as const

/**
 * 合法的环境变量 union
 */
export type EnvVar = (typeof envList)[number]

// init env vars with process.env
const envMap: { [key: string]: string } = {
  ...(process.env as { [key: string]: string }),
}

const getRealKey = (key: string) => `REACT_APP_${key}`

/**
 * 读取环境变量
 *
 * @param key - 环境变量的 key
 * @returns 环境变量的值
 */
export function env(key: EnvVar): string {
  return envMap[getRealKey(key)] as string
}

/**
 * 判断当前是否是测试环境
 *
 * @returns 判断结果
 */
export function isDev(): boolean {
  return process.env['ENV'] === 'development'
}
